/* eslint-disable no-console */
import { takeLatest, put } from 'redux-saga/effects';
import * as TypeActions from '../store/calendarioFeriado/actionsTypes';
import BaseService from '../services/BaseService';
import * as ToastTypeActions from '../store/toast/actionsTypes';
import * as LoaderTypeActions from '../store/loader/actionsTypes';

function* loadMunicipioUsuario({ callback }) {
  try {
    const response = yield BaseService.get({ url: 'calendario/municipio-usuario' });
    yield put({
      type: TypeActions.CALENDARIO_FERIADO_LOAD_MUNICIPIO_USUARIO_SUCCESS,
      data: response.data,
    });
    if (callback) yield callback(response.data);
  } catch (error) {
    console.log(error);
    if (callback) yield callback(null);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message: 'Erro ao identificar o município do usuário!',
    });
  }
}

function* loadCalendarioPublico({ codigosIbge, ano, callback }) {
  const ibges = (codigosIbge || []).filter(Boolean).map(String);
  if (!ibges.length) {
    return;
  }

  try {
    const url = `calendario/${ano}?codigoIbge=${ibges.join(',')}`;
    const response = yield BaseService.get({ url });
    yield put({
      type: TypeActions.CALENDARIO_FERIADO_LOAD_PUBLICO_SUCCESS,
      data: response.data,
    });
    if (callback) yield callback(true, response.data);
  } catch (error) {
    console.log(error);
    let message = 'Erro ao carregar o calendário de feriados!';
    if (error.response && error.response.status === 403) {
      message = 'Sem permissão para visualizar o calendário deste município.';
    } else if (error.response && error.response.data && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }
    if (callback) yield callback(false);
    yield put({ type: TypeActions.CALENDARIO_FERIADO_LOAD_PUBLICO_FAIL });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message,
    });
  }
}

function* loadCalendarioAdminCalendar({ filter, callback }) {
  try {
    const response = yield BaseService.post({
      url: 'calendario/filter/calendario',
      data: filter || {},
    });
    const data = Array.isArray(response.data) ? response.data : [];
    yield put({
      type: TypeActions.CALENDARIO_FERIADO_LOAD_ADMIN_CALENDAR_SUCCESS,
      data,
    });
    if (callback) yield callback(true, data);
  } catch (error) {
    console.log(error);
    let message = 'Erro ao carregar o calendário de gestão!';
    if (error.response && error.response.status === 403) {
      message = 'Sem permissão para visualizar o calendário de gestão.';
    } else if (error.response && error.response.status === 404) {
      message = 'Endpoint de calendário admin ainda não disponível no servidor.';
    } else if (error.response && error.response.data && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }
    if (callback) yield callback(false);
    yield put({ type: TypeActions.CALENDARIO_FERIADO_LOAD_ADMIN_CALENDAR_FAIL });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message,
    });
  }
}

function* loadMunicipiosUsuariosAtivos({ callback }) {
  try {
    const response = yield BaseService.get({
      url: 'calendario/municipios-usuarios-ativos',
    });
    const data = Array.isArray(response.data) ? response.data : [];
    yield put({
      type: TypeActions.CALENDARIO_FERIADO_LOAD_MUNICIPIOS_USUARIOS_ATIVOS_SUCCESS,
      data,
    });
    if (callback) yield callback(true, data);
  } catch (error) {
    console.log(error);
    let message = 'Erro ao carregar municípios de usuários ativos!';
    if (error.response && error.response.status === 403) {
      message = 'Sem permissão para listar municípios de usuários ativos.';
    } else if (error.response && error.response.status === 404) {
      // Endpoint ainda não publicado — admin cai no seletor nacional via fallback no UI.
      message = null;
    } else if (error.response && error.response.data && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }
    if (callback) yield callback(false);
    yield put({ type: TypeActions.CALENDARIO_FERIADO_LOAD_MUNICIPIOS_USUARIOS_ATIVOS_FAIL });
    if (message) {
      yield put({
        type: ToastTypeActions.TOAST_MESSAGE_ERROR,
        message,
      });
    }
  }
}

function* criarFeriado({ data, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.post({ url: 'calendario', data });
    yield put({
      type: TypeActions.CALENDARIO_FERIADO_CRIAR_SUCCESS,
      data: response.data,
    });
    if (callback) yield callback(true, response.data);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Feriado criado com sucesso!',
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    let message = 'Erro ao criar o feriado!';
    if (error.response && error.response.status === 403) {
      message = 'Sem permissão para criar feriados.';
    } else if (error.response && error.response.data && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }
    if (callback) yield callback(false);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({ type: ToastTypeActions.TOAST_MESSAGE_ERROR, message });
  }
}

function* atualizarFeriado({ data, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.put({ url: `calendario/${data.id}`, data });
    yield put({
      type: TypeActions.CALENDARIO_FERIADO_ATUALIZAR_SUCCESS,
      data: response.data,
    });
    if (callback) yield callback(true, response.data);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Feriado atualizado com sucesso!',
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    let message = 'Erro ao atualizar o feriado!';
    if (error.response && error.response.status === 403) {
      message = 'Sem permissão para atualizar feriados.';
    } else if (error.response && error.response.data && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }
    if (callback) yield callback(false);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({ type: ToastTypeActions.TOAST_MESSAGE_ERROR, message });
  }
}

function* invalidarFeriado({ id, motivo, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.post({
      url: `calendario/${id}/invalidar`,
      data: { motivo },
    });
    yield put({
      type: TypeActions.CALENDARIO_FERIADO_INVALIDAR_SUCCESS,
      data: response.data,
    });
    if (callback) yield callback(true, response.data);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Feriado invalidado com sucesso!',
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    let message = 'Erro ao invalidar o feriado!';
    if (error.response && error.response.status === 403) {
      message = 'Sem permissão para invalidar feriados.';
    } else if (error.response && error.response.data && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }
    if (callback) yield callback(false);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({ type: ToastTypeActions.TOAST_MESSAGE_ERROR, message });
  }
}

function* revalidarFeriado({ id, callback }) {
  try {
    yield put({ type: LoaderTypeActions.LOADER_SHOW });
    const response = yield BaseService.post({ url: `calendario/${id}/revalidar` });
    yield put({
      type: TypeActions.CALENDARIO_FERIADO_REVALIDAR_SUCCESS,
      data: response.data,
    });
    if (callback) yield callback(true, response.data);
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Feriado revalidado com sucesso!',
    });
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
  } catch (error) {
    let message = 'Erro ao revalidar o feriado!';
    if (error.response && error.response.status === 403) {
      message = 'Sem permissão para revalidar feriados.';
    } else if (error.response && error.response.data && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }
    if (callback) yield callback(false);
    yield put({ type: LoaderTypeActions.LOADER_HIDE });
    yield put({ type: ToastTypeActions.TOAST_MESSAGE_ERROR, message });
  }
}

export default function* watchCalendarioFeriado() {
  yield takeLatest(TypeActions.CALENDARIO_FERIADO_LOAD_MUNICIPIO_USUARIO, loadMunicipioUsuario);
  yield takeLatest(TypeActions.CALENDARIO_FERIADO_LOAD_PUBLICO, loadCalendarioPublico);
  yield takeLatest(TypeActions.CALENDARIO_FERIADO_LOAD_ADMIN_CALENDAR, loadCalendarioAdminCalendar);
  yield takeLatest(
    TypeActions.CALENDARIO_FERIADO_LOAD_MUNICIPIOS_USUARIOS_ATIVOS,
    loadMunicipiosUsuariosAtivos
  );
  yield takeLatest(TypeActions.CALENDARIO_FERIADO_CRIAR, criarFeriado);
  yield takeLatest(TypeActions.CALENDARIO_FERIADO_ATUALIZAR, atualizarFeriado);
  yield takeLatest(TypeActions.CALENDARIO_FERIADO_INVALIDAR, invalidarFeriado);
  yield takeLatest(TypeActions.CALENDARIO_FERIADO_REVALIDAR, revalidarFeriado);
}
